import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { id: "photo-gallery" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("h1", null, "GALLERIES", -1 /* HOISTED */);
const _hoisted_3 = { key: 0 };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["id"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("main", _hoisted_1, [
        _createElementVNode("menu", null, [
            _hoisted_2,
            (_ctx.list)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (galleries, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                            onClick: ($event) => (_ctx.goToYear(galleries.year)),
                            key: index
                        }, _toDisplayString(galleries.year), 9 /* TEXT, PROPS */, _hoisted_4));
                    }), 128 /* KEYED_FRAGMENT */))
                ]))
                : _createCommentVNode("v-if", true)
        ]),
        (_ctx.list)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.list, (galleries, index) => {
                return (_openBlock(), _createElementBlock("section", {
                    id: `year_${galleries.year}`,
                    key: index
                }, [
                    _createElementVNode("h2", null, [
                        _createElementVNode("span", null, _toDisplayString(galleries.year) + " Galleries ", 1 /* TEXT */)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(galleries.items, (gallery) => {
                        return (_openBlock(), _createElementBlock("figure", {
                            key: gallery.id,
                            style: _normalizeStyle(`background-image: url(/images/galleries/images/${gallery.thumbnail})`)
                        }, [
                            _createVNode(_component_router_link, {
                                to: { name: 'Gallery', params: { id: gallery.id } }
                            }, null, 8 /* PROPS */, ["to"]),
                            _createElementVNode("figcaption", null, _toDisplayString(gallery.title), 1 /* TEXT */)
                        ], 4 /* STYLE */));
                    }), 128 /* KEYED_FRAGMENT */))
                ], 8 /* PROPS */, _hoisted_5));
            }), 128 /* KEYED_FRAGMENT */))
            : _createCommentVNode("v-if", true)
    ]));
}
